/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable prettier/prettier */
'use client';
import { Content } from '.generated/Feature.CW.model';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { SvgIcon } from 'helpers/SvgIcon';
import { useState } from 'react';

export type AlertProps = Content.Alert;

const Alert = (props: AlertProps): JSX.Element => {
  const IsWarning = props?.fields?.isWarning?.value;
  const [isOpen, setIsOpen] = useState(true);

  const onEnterKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || ' ') {
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Wrapper  */}
      <div
        className={`${IsWarning ? 'theme-red' : 'theme-aqua'} mx-auto w-full bg-theme-bg transition-all duration-300 ease-in-out ${!isOpen ? 'transform -translate-y-full opacity-0' : 'transform translate-y-0 opacity-100'}`}
      >
        {/* Content */}
        <div className="lg:flex mx-auto max-w-[1280px] justify-between pt-8 pb-12 items-center px-10 xl:px-0">
          <div>
            <div
              className="flex items-center py-5"
              role={`${IsWarning ? 'alert' : 'status'}`}
              aria-live={`${IsWarning ? 'assertive' : 'polite'}`}
            >
              <button>
                {IsWarning ? (
                  <SvgIcon
                    icon="info"
                    className="!text-theme-text leading-none"
                    size="lg"
                    aria-label="warning alert"
                  />
                ) : (
                  <SvgIcon
                    icon="bell"
                    className="!text-theme-text leading-none"
                    size="lg"
                    aria-label="Neutral alert"
                  />
                )}
              </button>
              <Text
                field={props?.fields?.title}
                tag="p"
                className="lg:text-22 lg:leading-31 text-20 leading-28 pl-8 font-centuryGothic text-theme-text font-bold"
              />
              {/* Close button for mobile and tablet view */}
              <button onClick={() => setIsOpen(false)} className="ml-auto block lg:hidden ">
                <SvgIcon icon="close" size="lg" className="text-theme-text-btn-disabled-text" />
              </button>
            </div>
            <div className="pt-2 text-16 font-[500] leading-25 text-gray-900">
              <RichTextWrapper field={props?.fields?.description} />
            </div>
          </div>
          <div className="lg:flex items-center gap-[32px] pt-8 lg:pt-0 md:w-fit">
            <LinkWrapper
              field={props?.fields?.buttonLink}
              ctaVariant="secondary"
              suppressNewTabIcon={false}
            />
            {/* Close button for Desktop view */}
            <button onClick={() => setIsOpen(false)} onKeyDown={(e) => onEnterKeyDown(e)}>
              <SvgIcon
                icon="close"
                size="lg"
                className="text-theme-text-btn-disabled-text lg:block hidden"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Alert;
